import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import { ChannelTypes } from 'pages/ChannelPage/channelType'
import styles from './ChannelListItem.module.scss'
import { NATIVE_APP_HELPER } from 'constants/native_app_helper.constants'
import { NativeChannelListItem } from './NativeChannelListItem'

interface Props {
  channelSubdomain: string
  channelName: string
  channelLogo: string
  sportLabel: string
  rootDomain?: string
  channelType?: ChannelTypes
  showBorder?: boolean
}

const generateLink = (
  appDomain: string,
  rootDomain: string | undefined,
  subDomain: string
) => {
  if (
    rootDomain === appDomain ||
    NATIVE_APP_HELPER.SOLID_SPORT_APP.IS_CURRENT_DOMAIN
  ) {
    return `/${subDomain}`
  }
  return `https://${
    rootDomain || NATIVE_APP_HELPER.SOLID_SPORT_APP.GET_DOMAIN
  }/${subDomain}`
}

export const NativeChannelListItemLink: FC<Props> = ({
  channelSubdomain,
  channelName,
  channelLogo,
  sportLabel,
  rootDomain,
  channelType,
  showBorder = false
}) => {
  const appDomain = window.location.hostname
  const linkUrl = generateLink(appDomain, rootDomain, channelSubdomain)

  const linkProps = {
    'data-testid': 'channel-item-link',
    className: styles.LinkContainer
  }

  const channelListItemProps = {
    logo: channelLogo,
    name: channelName,
    sportLabel: sportLabel,
    rootDomain: rootDomain,
    channelType: channelType,
    showBorder: showBorder
  }

  if (
    rootDomain === appDomain ||
    NATIVE_APP_HELPER.SOLID_SPORT_APP.IS_CURRENT_DOMAIN
  ) {
    return (
      <Link to={linkUrl} {...linkProps}>
        <NativeChannelListItem {...channelListItemProps} />
      </Link>
    )
  }
  return (
    <a target="_blank" href={linkUrl} rel="noopener noreferrer" {...linkProps}>
      <NativeChannelListItem {...channelListItemProps} />
    </a>
  )
}
